import { useCallback, useState } from 'react';

export default function withCollapsibleState(MyComponent) {
  return function WithCollapsibleState(props) {
    const [shouldShowMore, setShouldShowMore] = useState(false);

    const handleMoreClick = useCallback(() => {
      setShouldShowMore((prev) => !prev);
    }, []);

    const resetCollapsibleState = useCallback(() => {
      setShouldShowMore(false);
    }, []);

    return (
      <MyComponent
        {...props}
        handleMoreClick={handleMoreClick}
        shouldShowMore={shouldShowMore}
        resetCollapsibleState={resetCollapsibleState}
      />
    );
  };
}
